import { Controller } from "@hotwired/stimulus"
import { renderPdfIntoContainer } from "../utils/pdf_viewer"

export default class extends Controller {
  static targets = ["viewer"]
  static values = { url: String, gap: Boolean }

  connect() {
    document.getElementById("modal-box")?.classList.add("legal-modal")

    if (this.urlValue) this.render(this.urlValue)
  }

  // Used when one controller instance serves multiple documents (e.g. two
  // links sharing a single inline modal) — each click supplies its own URL.
  open({ params: { url } }) {
    this.render(url)
  }

  render(url) {
    renderPdfIntoContainer(this.viewerTarget, url, { gap: this.gapValue })
  }
}
